/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SenderIdRequestBaseModel } from './senderIdRequestBaseModel';
import { SenderIdRequestStatus } from './senderIdRequestStatus';
import { SenderIdType } from './senderIdType';


export interface SenderIdRequestModel extends SenderIdRequestBaseModel { 
    id: string;
    authorizationLetter?: string;
    regCertificate?: string;
    loginUrl?: string;
    aggregatorId?: string;
}
